var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowEggFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5C3.95518 15.5 0.499999 12.1277 0.5 8C0.5 3.87226 3.95518 0.499999 8.25 0.499999C10.431 0.499999 13.7911 1.36741 16.6083 2.7895C18.0129 3.49853 19.2527 4.33084 20.1343 5.23507C21.0187 6.14229 21.5 7.07604 21.5 8C21.5 8.92396 21.0187 9.85772 20.1343 10.7649C19.2527 11.6692 18.0129 12.5015 16.6083 13.2105C13.7911 14.6326 10.431 15.5 8.25 15.5Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEggFilled);
export default __webpack_public_path__ + "static/media/arrow-egg-filled.28e446f6d995063e1b72aa258fa8c6cd.svg";
export { ForwardRef as ReactComponent };